import { RouteLocation } from 'vue-router';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import { usePermission } from '@models/profile/useProfilePermission';
import analyticsService from '@assets/services/analytics.service';

const { profileInfo, profileCurrentMenu, profileCurrentProduct } = useProfileInfo();
const { hasExperienceV4Permission, hasIntegrationPermission, getPermission } = usePermission();

export default {
    beforeEnterExperience(to: RouteLocation, from: RouteLocation, next: any) {
        analyticsService.sendProductActiveTime('ptx');
        next();
    },
    beforeEnterExperienceV3(to: RouteLocation, from: RouteLocation, next: any) {
        if (to.params?.path?.[0] === 'campaign' && hasExperienceV4Permission.value) {
            gotoV4(to, next);
        } else {
            next();
        }
    },
    beforeEnterExperienceV4(to: RouteLocation, from: RouteLocation, next: any) {
        if (nextGotoV3()) {
            gotoV3(to, next);
        } else {
            next();
        }
    },
    beforeEnterEngagement(to: any, from: any, next: any) {
        if (to.params.updatePermission) {
            getPermission(
                to.params.sid,
                () => {
                    enterEngagement(to, next);
                },
                () => {
                    next();
                }
            );
        } else {
            enterEngagement(to, next);
        }
    },
    beforeEnterIntegration(to: RouteLocation, from: RouteLocation, next: any) {
        if (hasIntegrationPermission.value) {
            next();
        } else {
            next({
                name: 'ProductList'
            });
        }
    }
};

async function enterEngagement(to: any, next: any) {
    if (nextGotoV3()) {
        gotoV3(to, next);
        return;
    }
    next();
}

function nextGotoV3() {
    return (
        !hasExperienceV4Permission.value ||
        (profileCurrentProduct.value?.key === 'experience' &&
            profileCurrentMenu.value &&
            profileCurrentMenu.value?.key !== 'CAMPAIGN')
    );
}

function gotoV3(to: RouteLocation, next: any) {
    next({
        name: 'ExperienceV3',
        params: {
            sid: profileInfo.value?.sid || to.params.sid
        }
    });
}

function gotoV4(to: RouteLocation, next: any) {
    next({
        name: 'ExperienceList',
        params: {
            sid: profileInfo.value?.sid || to.params.sid
        }
    });
}
